import { trackEvent } from "@adsk/acc-issues-core/utils/analytics/trackEvent";
import {
  IssueDrawerViewAnalyticsEvent,
  IssueLogPaginationAnalyticsEvent,
  IssueLogViewAnalyticsEvent,
  IssueSettingPageViewAnalyticsEvent,
  IssueSettingTabsClickAnalyticsEvent,
} from "./analyticsLib093IssuesEvents";

export type TrackSettingsPageViewInterface = ConstructorParameters<
  typeof IssueSettingPageViewAnalyticsEvent
>[0];

export const trackDrawerView = ({
  issueUid,
  deleted,
}: ConstructorParameters<typeof IssueDrawerViewAnalyticsEvent>[0]) => {
  trackEvent(new IssueDrawerViewAnalyticsEvent({ issueUid, deleted }));
};

export const trackSettingsPageView = ({
  pageType,
}: TrackSettingsPageViewInterface) => {
  trackEvent(
    new IssueSettingPageViewAnalyticsEvent({
      pageType,
    })
  );
};

export const trackIssueSettingTabsClick = (issueSettingTabsClick: string) => {
  trackEvent(
    new IssueSettingTabsClickAnalyticsEvent({
      issue_setting_tabs_click: issueSettingTabsClick,
    })
  );
};

export const trackIssueLogView = ({
  isDeletedLog,
}: {
  isDeletedLog: boolean;
}) => {
  trackEvent(new IssueLogViewAnalyticsEvent({ isDeletedLog: isDeletedLog }));
};

export const trackIssueLogPagination = (action: string) => {
  trackEvent(
    new IssueLogPaginationAnalyticsEvent({
      action,
    })
  );
};
